import DOMPurify from "dompurify";

interface RichTextProps {
  html: string | null | undefined;
  className?: string;
  style?: React.CSSProperties;
}

const PURIFY_CONFIG = {
  ALLOWED_TAGS: ["p", "br", "strong", "em", "u", "ul", "ol", "li", "h2", "h3", "span", "div"],
  ALLOWED_ATTR: ["style"],
};

function isHtml(text: string): boolean {
  return /<[a-z][\s\S]*>/i.test(text);
}

export function RichText({ html, className, style }: RichTextProps) {
  if (!html) return null;

  // Plain text fallback — preserve line breaks
  if (!isHtml(html)) {
    return (
      <div className={`rich-text ${className || ""}`} style={{ ...style, whiteSpace: "pre-line" }}>
        {html}
      </div>
    );
  }

  const clean = DOMPurify.sanitize(html, PURIFY_CONFIG);

  return (
    <div
      className={`rich-text ${className || ""}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
